/// <amd-module name="Wit/WorkItemModel/RuleEngine/ServerDefaultValue" />
import { ServerDefaultValueType } from "../OM";

export class ServerDefaultValue {
    public type: ServerDefaultValueType = ServerDefaultValueType.None;
    public value: any;

    constructor(type: ServerDefaultValueType, originalValue: any) {
        this.type = type;
        this.value = originalValue;
    }

    public toString(): string {
        return "" + this.value;
    }

    public valueOf(): any {
        return this.value;
    }
}
